export default "__VITE_ASSET__CF7zRbBp__"